import React, { useMemo, useState, useEffect, useCallback } from 'react';
import { Select } from '@panwds/react-ui';
import { useFilters } from '../../../hooks/useFilters/useFilters.esm.js';
import { actions } from '../../../state/actions.esm.js';
import '../../../state/reducer.esm.js';
import { AddButton } from './AddButton.esm.js';

const AddFilter = ({ normalizedFilterConfig, disabled, isLoading, dataMetrics, onFilterTypeAdded, onFilterTypeRemoved, addFilterLabel, }) => {
    const { displayedFilters, dispatch, name } = useFilters();
    const items = useMemo(() => Object.values(normalizedFilterConfig).map((filter) => ({
        children: filter.label,
        value: filter.name,
        disabled: filter.disabled || filter.static,
    })), [normalizedFilterConfig]);
    const getDefaultSelectedItems = () => {
        const defaultSelectedItems = items.filter((item) => displayedFilters.includes(item.value));
        return defaultSelectedItems.length > 0 ? defaultSelectedItems : [];
    };
    const [currentlySelectedItems, setCurrentlySelectedItems] = useState(getDefaultSelectedItems());
    useEffect(() => {
        setCurrentlySelectedItems(getDefaultSelectedItems());
    }, [displayedFilters]);
    const addFilter = useCallback((props) => {
        const { selectedItem, selectedItems, inputValue } = props;
        const selectedFilterName = selectedItem.value;
        const currentItems = selectedItems.map((item) => item.value);
        const currentSelectableItems = selectedItems.filter((item) => !(item.disabled || item.static));
        const index = currentItems.indexOf(selectedFilterName);
        const isNewlyAddedItem = index >= 0;
        const isSelectAll = !inputValue;
        if (isSelectAll) {
            const { checked } = selectedItem;
            dispatch({
                type: checked ? actions.removeAllFilters : actions.displayAllFilters,
                payload: {
                    name,
                },
            });
            if (checked && onFilterTypeRemoved) {
                const selectedItemList = items
                    .filter((item) => !item.disabled)
                    .map((item) => item.value);
                onFilterTypeRemoved(selectedItemList);
            }
            setCurrentlySelectedItems(selectedItems);
            // When Select All is checked, call the callback with all selected & enabled filters
            if (!checked && onFilterTypeAdded) {
                onFilterTypeAdded(currentSelectableItems.map((item) => item.value));
            }
        }
        else if (isNewlyAddedItem) {
            dispatch({
                type: actions.displayFilter,
                payload: {
                    name,
                    filterName: selectedFilterName,
                },
            });
            // call the callback with currently selected filter
            if (onFilterTypeAdded) {
                onFilterTypeAdded([selectedFilterName]);
            }
        }
        else {
            dispatch({
                type: actions.removeFilter,
                payload: {
                    name,
                    filterName: selectedFilterName,
                },
            });
            // call the callback with currently selected filter
            onFilterTypeRemoved === null || onFilterTypeRemoved === void 0 ? void 0 : onFilterTypeRemoved([selectedFilterName]);
        }
    }, [name, onFilterTypeAdded, onFilterTypeRemoved]);
    return (React.createElement(Select, { button: React.createElement(AddButton, { disabled: disabled, isLoading: isLoading, showLabel: !displayedFilters.length, dataMetrics: `${dataMetrics}`, addFilterLabel: addFilterLabel }), disabled: disabled || isLoading, items: items, selectedItem: currentlySelectedItems, onChange: addFilter, enableMultiSelect: true, enableSelectAll: true, enableSearch: true, dataMetrics: `${dataMetrics}-dropdown-add-remove` }));
};

export { AddFilter };
//# sourceMappingURL=AddFilter.esm.js.map
